import React from "react";
import { Instagram, Linkedin, Mail, MapPin, Phone, User } from "react-feather";
import { InertiaLink } from "@inertiajs/inertia-react";
import { Container } from "@/Components/Container";
import { Button } from "@/Components";
import { Inertia } from "@inertiajs/inertia";

const HomeLayout = ({ children }) => {
  return (
    <>
      <header className="w-full border-b-[1px] border-b-[#e9eceb] bg-background ">
        <Container
          size="max-w-[1182px]"
          className="flex w-full justify-between py-4"
        >
          <div className="flex items-center">
            <InertiaLink href="/" aria-label="Go to startpage">
              <img src="/images/gidas_logo_new.svg" alt="Emma" />
            </InertiaLink>
          </div>

          <div className="flex items-center">
            <ul className="flex">
              <li>
                <InertiaLink
                  href="/login"
                  className="flex h-full cursor-pointer select-none items-center whitespace-nowrap px-4 py-2 hover:bg-gray"
                >
                  <User
                    className="mr-2 inline w-10 rounded-full bg-primary p-2 text-center font-semibold text-white"
                    size={40}
                  />
                  <span className="ml-2">Log in</span>
                </InertiaLink>
              </li>
            </ul>
          </div>
        </Container>
      </header>

      <main className="flex flex-col bg-gray-lighter pb-10 lg:gap-20 lg:pb-20">
        {children}
      </main>

      <footer className="w-full w-full  flex-col gap-10 bg-gray pt-10 lg:gap-20 lg:pt-20">
        <Container size="max-w-[1182px] pb-10 lg:pb-20 flex w-full items-center justify-center border border-dashed border-b-teal-900 px-16 max-md:px-0">
          <div className="flex w-[655px] max-w-full flex-col">
            <h2 className="text-center text-5xl max-md:text-4xl font-rozhaone">
              Not sure how to begin?
            </h2>
            <p className="mt-2 text-center">
              Take our test and and make your first move.
            </p>
            <Button
              className="mt-8 self-center"
              onClick={() => {
                Inertia.visit(`${route("home")}#test`);
              }}
            >
              Start test
            </Button>
          </div>
        </Container>

        <div className="relative pt-10 lg:pt-20">
          <Container
            size="max-w-[1182px]"
            className="flex flex-col gap-4 pb-20 lg:pb-40"
          >
            <h3 className="mt-4 text-3xl leading-9 font-rozhaone">
              Gidås Hållbarhetsbyrå AB
            </h3>
            <a
              className="hover:underline"
              href="tel:+46633916010"
              target="_blank"
            >
              <Phone size={16} className="mb-1 inline-block" /> 063 391 60 10
            </a>
            <a
              className="hover:underline"
              href="mailto:hej@gidas.se"
              target="_blank"
            >
              <Mail size={16} className="mb-1 inline-block" /> hej@gidas.se
            </a>
            <a
              className="hover:underline"
              href="mailto:hej@gidas.se"
              target="_blank"
            >
              <MapPin size={16} className="mb-1 inline-block" /> Prästgatan 44,
              Östersund
            </a>

            <div className="mt-4 flex gap-4">
              <a
                href="https://www.instagram.com/gidashallbarhetsbyra/"
                target="_blank"
              >
                <Instagram size={48} strokeWidth={1} />
              </a>
              <a
                href="https://www.linkedin.com/company/gidasagency/"
                target="_blank"
              >
                <Linkedin size={48} strokeWidth={1} />
              </a>
            </div>
          </Container>

          <img
            src="/images/home/stocken.png"
            alt=""
            role="presentation"
            className="absolute bottom-0 right-0 h-full max-md:opacity-10"
          />
        </div>
      </footer>
    </>
  );
};

export default HomeLayout;
